<template lang="pug">
.plan-swiper-wrap
    .plan-swiper-pagination
    swiper(
        :slidesPerView="1"
        :spaceBetween="spaceBetween"
        :slideActiveClass="'on'"
        :pagination="{ el: '.plan-swiper-pagination', clickable: true, bulletActiveClass: 'on', renderBullet: makeBullet }"
        :breakpoints="swiperBreakpoints"
        :modules="[Pagination]"
    )
        swiper-slide.plan-item.green(:class="standardSlideClass")
            svg.mark
                use(xlink:href="/material-icon.svg?v=20250829065753667#icon-card-mark")
            .top
                .title Standard
                    slot(name="standardTitleExtra")
            .middle
                .price(:class="priceClass")
                    .num {{ '$' + modelSpecs['Standard'].price }}
                    span.period /mon
                    .desc {{ modelSpecs['Standard'].description }}
                slot(name="standardAction")
            .bottom
                p Specs:
                ul
                    li(v-for="(desc, index) in modelSpecs['Standard'].offer_list" :key="index" :class="desc.class") {{ desc.text }}

        swiper-slide.plan-item.yellow(:class="premiumSlideClass")
            svg.mark
                use(xlink:href="/material-icon.svg?v=20250829065753667#icon-card-mark")
            .top
                .title Premium
                    slot(name="premiumTitleExtra")
            .middle
                .price(:class="priceClass")
                    .num {{ '$' + modelSpecs['Premium'].price }}
                    span.period /mon
                    .desc {{ modelSpecs['Premium'].description }}
                slot(name="premiumAction")
            .bottom
                p Specs:
                ul
                    li(v-for="(desc, index) in modelSpecs['Premium'].offer_list" :key="index" :class="desc.class") {{ desc.text }}
</template>

<script setup lang="ts">
import { modelSpecs } from "@/code/service-spec";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

withDefaults(defineProps<{
    standardSlideClass?: Record<string, boolean>;
    premiumSlideClass?: Record<string, boolean>;
    priceClass?: Record<string, boolean>;
    swiperBreakpoints?: Record<number, any>;
    spaceBetween?: number;
}>(), {
    standardSlideClass: () => ({}),
    premiumSlideClass: () => ({}),
    priceClass: () => ({}),
    swiperBreakpoints: () => ({
        0: { slidesPerView: 1, enabled: true, loop: false, spaceBetween: 30 },
        890: { slidesPerView: 2, enabled: false, loop: false }
    }),
    spaceBetween: 0,
});

function makeBullet(index: number, className: string) {
    let menu = ["Standard", "Premium"];
    return `<span class="${className}">${menu[index]}</span>`;
}
</script>
